import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";

const useStyles = createStyles(({ token, css }: any) => ({
  root: css``,
  itemImage: css`
    width: 120px !important;
    height: 120px !important;
    padding: 8px;
    background-color: ${token.ColorFigmaNeutralGrayscaleGray10};
  `,
  itemImageSmall: css`
    width: 64px !important;
    height: 64px !important;
    padding: 4px;
    background-color: ${token.ColorFigmaNeutralGrayscaleGray10};
  `,
  itemTitle: css`
    flex: 1;
  `,
  buttonCounter: css``,
  buttonCounterValue: css`
    pointer-events: none;
  `,
  buttonRemove: css``,
  buttonAdd: css``,
  price: css`
    & > * {
      text-align: right;
    }
  `,
}));

export const useStoreCartItemsStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
